// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"08c76e7e","239":"da542cef","389":"57159335","455":"f6c9f903","857":"e50bb8bf","977":"e42e6b0e"}[chunkId] + ".chunk.js";
};